import { Field, RichText, Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps, SitecoreContextValue } from 'src/lib/ComponentProps';

import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import ContentOverviewHeaderContainer from 'src/components/contentOverview/_contentOverviewHeaderContainer/ContentOverviewHeaderContainer';

import styles from './CourseOverviewFindOutMore.module.css';

type CourseOverviewFindOutMoreProps = ComponentProps & {
	fields: {
		Title: Field<string>;
		Subtitle: Field<string>;
		Text: Field<string>;
		EmailAddress: Field<string>;
		EmailSubject: Field<string>;
		PhoneNumber: Field<string>;
	};
};

export default function CourseOverviewFindOutMore(props: CourseOverviewFindOutMoreProps): JSX.Element {
	const { sitecoreContext } = useSitecoreContext<SitecoreContextValue>();
	const isEditing = IsSitecoreEditing();

	if (
		!isEditing &&
		props.fields?.EmailAddress?.value?.trim() === '' &&
		props.fields?.PhoneNumber?.value?.trim() === '' &&
		props.fields?.Text?.value.trim() === ''
	) {
		return <></>;
	}

	return (
		<div className={styles.contentOverviewFindOutMoreContainer}>
			<ContentOverviewHeaderContainer header={props.fields?.Title?.value} subHeader={props.fields?.Subtitle?.value} />

			<div className={styles.contentOverviewFindOutMoreWrapper}>
				<RichText field={props.fields?.Text} className={styles.contentOverviewFindOutMoreText} />

				<Text
					tag="a"
					href={`mailto:${props.fields?.EmailAddress?.value}?subject=${props.fields?.EmailSubject?.value?.replace(
						'$courseName$',
						`${sitecoreContext?.route?.fields?.PageTitle?.value}`
					)}`}
					field={props.fields?.EmailAddress}
					className={styles.contentOverviewFindOutMoreEmailAddress}
				/>

				<Text
					tag="a"
					href={`tel:${props.fields?.PhoneNumber?.value}`}
					field={props.fields?.PhoneNumber}
					className={styles.contentOverviewFindOutMoreContactDetails}
				/>
			</div>
		</div>
	);
}
